import ModalPresenter from "../../../modal/presenter/modal.js";

import ModalSectionView from "../view/modal-share-cart.js";

import {
  copyTextToClipboard
} from "../../../../utils/copy-text-to-clipboard.js";

import {
  ActionType,
  defaultModalModelData,
  MODAL_MAIN_CLASS
} from "../../const.js";
export default class ModalShareCart extends ModalPresenter {
  constructor({
    cartId
  }) {
    super();

    this._cartId = cartId;

    this._modalMainClass = MODAL_MAIN_CLASS;
    this._modalSectionView = new ModalSectionView();
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        defaultModalModelData
    ));

    this._handleCopyLinkButtonClick = this._handleCopyLinkButtonClick.bind(this);
  }

  _processInit() {
    this._model.changeData(Object.assign(
        {},
        this._model.getData(),
        {
          shareCartData: {
            url: `${document.location.origin}${document.location.pathname}?cart_id=${this._cartId}`
          }
        }
    ), ActionType.RENDER_DATA);
  }

  _processRenderData() {
    const shareCartData = this._model.getData().shareCartData;
    this._modalSectionView.applyLink(shareCartData.url);
    this._modalSectionView.setCopyLinkButtonClickHandler(this._handleCopyLinkButtonClick);
  }

  _handleChangeData(action, payload) {
    super._handleChangeData(action, payload);

    switch (action) {
      case ActionType.RENDER_DATA:
        this._processRenderData();
        break;
    }
  }

  _handleCopyLinkButtonClick() {
    copyTextToClipboard(this._modalSectionView.getElement(), this._model.getData().shareCartData.url);
  }
}
